<template>
  <v-layout align-start>
    <v-flex>
      <v-app-bar>
        <v-toolbar-title class="font-weight-black primary--text"
          >Gastos de Personal</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="exportarExcel"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> sim_card_download </v-icon>
            </v-btn>
          </template>
          <span>Exportar a Excel</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="mostrarCarga"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> file_upload </v-icon>
            </v-btn>
          </template>
          <span>Carga masiva de datos</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nuevo registro</span>
        </v-tooltip>
      </v-app-bar>
      <v-data-table
        dense
        :headers="headers"
        :items="gastos"
        :items-per-page="2"
        :search="search"
        sort-by="codigo"
        class="elevation-1"
        :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página',
          'items-per-page-options': [50, 100, 150, -1],
        }"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-btn x-small text dark color="primary" @click="editItem(item)">
            <v-icon x-small>edit</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado == 'A'">
            <v-btn color="success" x-small text dark @click="desactivar(item)">
              <v-icon x-small>check</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" x-small text dark @click="activar(item)">
              <v-icon x-small>block</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.mes`]="{ item }">
          <a
            v-for="(month, index) in JSON.parse(item.mes)"
            x-small
            :key="index"
          >
            {{ meses.find((mt) => mt.id === month).descripcion + ", " }}
          </a>
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="font-weight-black primary--text">
            </v-toolbar-title>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda General"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchCodigoValue"
              append-icon="search"
              label="Búsqueda por código"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchDescripcionValue"
              append-icon="search"
              label="Búsqueda por descripción"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" persistent max-width="800px">
              <v-card ref="form">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="codigo"
                          v-model="codigo"
                          :rules="[rules.requerido, rules.max10, rules.min2]"
                          :error-messages="errorMessages"
                          label="Código"
                          placeholder="Código"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="descripcion"
                          v-model="descripcion"
                          :rules="[rules.requerido, rules.max50, rules.min2]"
                          :error-messages="errorMessages"
                          label="Descripción"
                          placeholder="Descripción"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                          outlined
                          dense
                          ref="id_cuenta_contable"
                          v-model="id_cuenta_contable"
                          :items="cuentasContables"
                          :rules="[rules.requerido]"
                          :error-messages="errorMessages"
                          item-text="descripcion"
                          item-value="id"
                          label="Cuenta Contable"
                          required
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                          outlined
                          dense
                          chips
                          deletable-chips
                          multiple
                          ref="mes"
                          v-model="mes"
                          :items="meses"
                          :rules="[rules.requerido2]"
                          :error-messages="errorMessages"
                          label="Meses"
                          item-text="descripcion"
                          item-value="id"
                          required
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          reverse
                          ref="monto"
                          v-model="monto"
                          :rules="[rules.numero, rules.requerido]"
                          :error-messages="errorMessages"
                          label="Monto"
                          required
                          style="text-align: right"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <div v-if="false">
                      <v-row>
                        <v-flex>
                          <v-data-table
                            dense
                            :headers="headersCargo"
                            :items="Cargos"
                            :search="searchCargo"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            sort-by="descripcion"
                            class="elevation-1"
                          >
                            <template v-slot:[`item.opciones`]="{ item }">
                              <v-btn
                                text
                                x-small
                                dark
                                color="primary"
                                @click="deleteItemCargo(item)"
                              >
                                <v-icon x-small>delete</v-icon>
                              </v-btn>
                            </template>
                            <template v-slot:[`item.id_ciudad`]="{ item }">
                              <v-chip
                                v-for="(ciu, index) in JSON.parse(
                                  item.id_ciudad
                                )"
                                class="ma-2"
                                color="primary"
                                text-color="white"
                                x-small
                                :key="index"
                              >
                                {{
                                  ciudades.find((cds) => cds.id === ciu)
                                    .descripcion
                                }}
                              </v-chip>
                            </template>

                            <template v-slot:top>
                              <v-app-bar>
                                <v-toolbar-title
                                  class="font-weight-black primary--text"
                                  >Cargos</v-toolbar-title
                                >
                                <v-spacer></v-spacer>

                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      large
                                      @click="addCargo"
                                      color="primary"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon dark> add </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Asignar cargo al Uniforme</span>
                                </v-tooltip>
                              </v-app-bar>

                              <v-divider vertical></v-divider>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>

                              <v-dialog
                                dense
                                persistent
                                v-model="dialogCargo"
                                max-width="500px"
                              >
                                <v-card ref="formCargo">
                                  <v-card-title>
                                    <span class="headline">Datos Cargo</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-autocomplete
                                            outlined
                                            dense
                                            chips
                                            deletable-chips
                                            multiple
                                            ref="id_cargo"
                                            v-model="id_cargo"
                                            :items="cargoList"
                                            :rules="[rules.requerido2]"
                                            :error-messages="errorMessages"
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Cargo"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-autocomplete
                                            outlined
                                            dense
                                            chips
                                            deletable-chips
                                            multiple
                                            ref="id_ciudad"
                                            v-model="id_ciudad"
                                            :items="ciudades"
                                            :rules="[rules.requerido2]"
                                            :error-messages="errorMessages"
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Ciudades"
                                            required
                                          >
                                          </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-text-field
                                            outlined
                                            dense
                                            reverse
                                            ref="frecuencia"
                                            v-model="frecuencia"
                                            :rules="[
                                              rules.numero,
                                              rules.requerido,
                                            ]"
                                            :error-messages="errorMessages"
                                            label="Dotaciones al año"
                                            required
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="closeCargo"
                                      >Cancelar</v-btn
                                    >
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="guardarCargo"
                                      >Guardar</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                              <v-dialog
                                v-model="dialogBorrarCargo"
                                persistent
                                max-width="290"
                              >
                                <v-card>
                                  <v-card-title class="headline"
                                    >¿Está seguro?</v-card-title
                                  >
                                  <v-card-text
                                    >Esta acción borrará la asignación de Cargo
                                    al Uniforme.</v-card-text
                                  >
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      @click="dialogBorrarCargo = false"
                                      >Cancelar</v-btn
                                    >
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="eliminarCargo()"
                                      >Continuar</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </template>
                            <template v-slot:no-data>
                              <v-btn
                                color="primary"
                                @click="listarUniformeCargo"
                                >Reset</v-btn
                              >
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-row>
                    </div>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">Cancelar</v-btn>
                  <v-btn color="primary" text @click="guardar">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      gastos: [],
      fruits: ["apple", "banana", "orange"],
      dialog: false,
      dialogUpload: false,
      dialogCargo: false,
      dialogBorrarCargo: false,

      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mes",
          value: "mes",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Monto",
          value: "monto",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersCargo: [
        {
          text: "Cargo",
          value: "cargo",
        },
        {
          text: "Dotaciones",
          value: "frecuencia",
          align: "right",
        },
        {
          text: "Ciudades",
          value: "id_ciudad",
          align: "left",
        },
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        requerido2: (value) => !!value[0] || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchCargo: "",
      searchCodigoValue: "",
      searchDescripcionValue: "",
      usuario: this.$store.state.usuario.user,
      rol: this.$store.state.usuario.rol,
      CargosList: [],
      Cargos: [],
      ciudades: [],

      editedIndex: -1,
      editedIndexCco: false,
      editCodigo: false,
      mostrarErrores: false,

      id: "",
      id_cargo: [],
      id_ciudad: [],
      cuentasContables: [],
      codigo: "",
      descripcion: "",
      frecuencia: "",
      monto: "",
      id_cuenta_contable: "",
      tipo_presupuesto: "NOM",
      file: null,
      mes: [],
      valida: 0,

      validaMensaje: [],
      cargoList: [],
      areaList: [],
      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],
      adCodigo: "",
      errorMessages: "",
      errorMessagesCargo: "",
      error: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        mes: this.mes,
        monto: this.monto,
      };
    },

    formCargo() {
      return {
        id_cargo: this.id_cargo,
        frecuencia: this.frecuencia,
        id_ciudad: this.id_ciudad,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesCargo = "";
    },
  },

  created() {
    this.listar();
    this.selectCargo();
    this.selectCiudades();
    this.selectCuentasContables();
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    closeCargo() {
      this.dialogCargo = false;
      this.limpiarCargo();
    },

    exportarExcel() {
      let me = this;
      try {
        json2excel({
          data: me.gastos,
          name: "Uniforme",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);

        axios
          .put("api/gastos/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/gastos/listar")
        .then(function (response) {
          me.gastos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarUniformeCargo() {
      let me = this;

      axios
        .get("api/uniforme_cargos/listarUniformeCargo/" + this.id)
        .then(function (response) {
          me.Cargos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCargo() {
      let me = this;
      axios
        .get("api/cargos/select/")
        .then(function (response) {
          me.cargoList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCuentasContables() {
      let me = this;
      axios
        .get(
          "api/cuenta_contables/SelectTipoPresupuesto/" + me.tipo_presupuesto + "/"+ me.usuario
        )
        .then(function (response) {
          me.cuentasContables = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.areaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectCiudades() {
      let me = this;
      axios
        .get("api/ciudades/SelectDepartamentosBolivia")
        .then(function (response) {
          me.ciudades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },

    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.id_cuenta_contable = item.id_cuenta_contable;
      this.mes = item.mes === "" ? JSON.parse("[]") : JSON.parse(item.mes);

      this.monto = item.monto;
      this.editedIndex = 1;
      this.editCodigo = false;

      this.listarUniformeCargo();

      this.selectArea();

      this.dialog = true;
    },

    addItem() {
      this.editCodigo = true;
      this.dialog = true;
    },

    addCargo() {
      this.dialogCargo = true;
    },
    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    deleteItemCargo(item) {
      this.id_cargo = item.id_cargo;
      this.dialogBorrarCargo = true;
    },
    editItemCargo(item) {
      this.id_ciudad =
        item.id_ciudad === "" ? JSON.parse("[]") : JSON.parse(item.id_ciudad);

      this.frecuencia = item.frecuencia;
      this.dialogCargo = true;
      this.id_cargo = [item.id_cargo];
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    eliminarCargo() {
      let me = this;

      axios
        .put(
          "api/uniforme_cargos/EliminarUniformeCargo/" +
            me.id +           
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.listarUniformeCargo();
          me.$store.dispatch("setSnackbar", {
            text: "Cargo eliminada exitosamente.",
            color: "success",
          });
          me.dialogBorrarCargo = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";

      this.mes = [];

      this.monto = "";
      this.validaMensaje = [];
      this.editedIndex = -1;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    limpiarCargo(item) {
      this.id_cargo = [];
      this.frecuencia = "";
      this.id_ciudad = [];
      this.Cargos = [];
      this.editedIndexCco = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put("api/gastos/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_cuenta_contable: me.id_cuenta_contable,
            mes: me.mes,
            monto: me.monto,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        console.log("-------------------");
        console.log(me.codigo);
        console.log(me.mes);
        console.log(me.descripcion);
        console.log(me.usuario);
        console.log("------------------");

        axios
          .post("api/gastos/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_cuenta_contable: me.id_cuenta_contable,
            mes: me.mes,
            monto: me.monto,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.editCodigo = false;
            me.listar();
            me.id = response.data;
            me.editedIndex = 1;
            me.listarUniformeCargo();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarCargo() {
      if (this.validarCargo() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/uniforme_cargos/actualizar", {
            id_uniforme: me.id,
            id_cargo: me.id_cargo,
            id_ciudad: me.id_ciudad,
            frecuencia: me.frecuencia,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCargo();
            me.listarUniformeCargo();
            me.limpiarCargo();

            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/Uniforme_cargos/crear", {
            id_uniforme: me.id,
            id_cargo: me.id_cargo,
            id_ciudad: me.id_ciudad,
            frecuencia: me.frecuencia,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCargo();
            me.listarUniformeCargo();
            me.limpiarCargo();

            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarCargo() {
      this.validaCargo = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formCargo).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaCargo += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaCargo += 1;
        }
      });
      return this.validaCargo;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/gastos/activar/" + item.id + "/" + item.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "info",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/gastos/desactivar/" + item.id + "/" + item.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "accent",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },
    filtroDescripcion(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchDescripcionValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchDescripcionValue.toLowerCase());
    },
  },
};
</script>
